import { InfoCircle } from '@assets/svgs';
import { JurisdictionItem } from '@models/brokerageOffering';
import { Select, Item } from '@components/select/Select';
import { CollapsedField } from '@components/quoteDetails/CollapsedField';
import { QFCTypeExecuted } from '@components/quoteDetails/QuoteFieldControl';
import { DataType } from '@services/data/productModelTypes';
import { AdditionalInfoLinkProps } from '@components/container/AdditionalInfoLink';

export interface SelectFieldProps extends QFCTypeExecuted {
  getOptionValues: ({ isOverriding }: { isOverriding: boolean }) => Item[];
  onBlur: () => void;
  isRequired: boolean;
  isRequiredBeforeBind?: boolean;
  additionalInfoLink?: AdditionalInfoLinkProps;
}

export const SelectField = ({
  setValue,
  attributeType,
  filteredJurisdictions,
  errorMessage,
  value,
  isCollapsed,
  hoverText,
  externalIcon,
  isRequired,
  isRequiredBeforeBind,
  isReadOnly,
  onBlur,
  getOptionValues,
  additionalInfoLink,
  isOverriding,
}: SelectFieldProps) => {
  let options = getOptionValues({ isOverriding });
  if (filteredJurisdictions && attributeType.codeName === 'StateCode') {
    const filteredAbbreviationList = filteredJurisdictions.map((el: JurisdictionItem) => el.abbreviation);
    options = options.filter((v) => filteredAbbreviationList.includes(v.value));
  }

  if (
    value !== undefined &&
    value !== null &&
    !options.find((v: { value: string; label: string }) => v.value == value)
  ) {
    const overrideOptions = getOptionValues({ isOverriding: true });

    const overrideOptionValueLabel =
      overrideOptions && overrideOptions?.find((v: { value: string; label: string }) => v.value == value)?.label;
    options.push({ value: value as string, label: `${overrideOptionValueLabel ?? value}`, hidden: true });
  }

  if (isCollapsed) {
    const selectedValue = options.find((option) => option.value == value);
    const label = value === null || value === undefined || value === '' ? undefined : selectedValue?.label;
    return <CollapsedField label={attributeType.label} value={label} deprecated={attributeType.deprecated} />;
  }
  const isMultiSelect = attributeType.dataType === DataType.StringList.toString();
  let selectValue = value?.toString() ?? '';
  if (isMultiSelect) {
    selectValue = value ? (!Array.isArray(value) ? [value] : value) : [];
  }

  return (
    <Select
      onBlur={onBlur}
      error={!!errorMessage}
      multiple={isMultiSelect}
      helperLabel={errorMessage ?? attributeType.helpText ?? ' '}
      fullWidth
      deprecated={attributeType.deprecated}
      inputLabel={attributeType.label ?? 'Missing label'}
      inputLabelIcon={hoverText ? <InfoCircle style={{ flexShrink: 0 }} /> : null}
      tooltipTitle={hoverText}
      externalIcon={externalIcon}
      required={isRequired}
      requiredBeforeBind={isRequiredBeforeBind}
      placeholder='Select'
      items={options}
      value={selectValue}
      onChange={(e) => setValue(e.target.value === '' || e.target.value === undefined ? null : e.target.value)}
      disabled={isReadOnly}
      additionalInfoLink={additionalInfoLink}
    />
  );
};
